import "./App.css";
import { Navbar, Nav, Container, Row, Col } from "react-bootstrap";
import logo from "./img/logo.png";
import Slider from "./Slider";
import MainHeading from "./MainHeading";
import Steps from "./Steps";
import Services from "./Services";
import Technologies from "./Technologies";
import Contact from "./Contact";
import Footer from "./Footer";
import Projects from "./Projects";
import { handleContextMenu } from "./const";
import darktrigger from './img/dark-trigger.jpeg'
import candymasti from './img/candy-masti.jpeg'

function App() {
  let width = window.innerWidth;

  return (
    <>
      <Navbar bg="light" variant="light" expand="lg" id={"home"}>
        <Container>
          <Navbar.Brand href="#home" className={width < 550 ? "w-70" : ""}>
            <img
              onContextMenu={handleContextMenu}
              className="w-80"
              src={logo}
              alt="SLP Technologie"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-end"
          >
            <Nav className="mr-auto">
              <Nav.Link href="#home"><b>Home</b></Nav.Link>
              <Nav.Link href="#Process"><b>Process</b></Nav.Link>
              <Nav.Link href="#Services"><b>Services</b></Nav.Link>
              <Nav.Link href="#Technologies"><b>Technologies</b></Nav.Link>
              <Nav.Link href="#games"><b>Our Games</b></Nav.Link>
              {/* <Nav.Link href="#Projects">Case Studies</Nav.Link> */}
              <Nav.Link href="#Contact"><b>Contact Us</b></Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {/* Slider */}
      <Slider />
      <Container>
        <Row className={`${width < 500 ? "mt-3" : "mt-5"}`}>
          <MainHeading
            title={"The"}
            spanTitle={"SLP Technologie Way"}
            id="Process"
          />
        </Row>
        <Row className="mt-2">
          <Col md={8} className="text-center m-auto">
            <p className="f-18">At <b>SLP Technologie IT Solutions</b>, we specialize in delivering cutting-edge web, mobile, and cloud solutions using the latest technologies. Our expert team ensures innovation, performance, and scalability for businesses across industries.</p>
          </Col>
        </Row>
      </Container>
      <Steps />
      {/* <Container>
        <div className={`row ${width < 500 ? "mt-3" : "mt-5"}`}>
          <MainHeading
            title={"Why Organizations Choose"}
            spanTitle={"SLP Technologie"}
            id="Projects"
          />
        </div>
      </Container>
      <Projects /> */}
      <Container>
        <Row className={`row ${width < 500 ? "mt-3" : "mt-5"}`} id="Services">
          <MainHeading title={"What Are We"} spanTitle={"Good At"} />
        </Row>
        <Services />
        <div className={`row ${width < 500 ? "mt-3" : "mt-5"}`}>
          <MainHeading
            title={"We Work with"}
            spanTitle={"Technologies"}
            id="Technologies"
          />
        </div>
         <Row className="mt-2">
          <Col md={8} className="text-center m-auto">
            <p className="f-18">
              At <b>SLP Technologie IT Solutions</b>, we build innovative, scalable, and secure digital solutions using the latest web, mobile, and cloud technologies. Our team transforms ideas into powerful software that drives business growth and success.
            </p>
          </Col>
        </Row>
        <Technologies />
         <Row className={`row ${width < 500 ? "mt-3" : "mt-5"}`} id="Services">
          <MainHeading title={"Our"} spanTitle={"Games"} id="games"/>
        </Row>
        <Row className="mt-2">
          <Col md={8} className="text-center m-auto">
            <p className="f-18">
             At <b>SLP Technologie IT Solutions</b>, we create high-quality, engaging, and performance-driven games that deliver immersive experiences. From concept to launch, our expert team blends creativity with technology to build games players love.
            </p>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md={6} className="text-center">
          <img onClick={() => window.open("https://play.google.com/store/apps/details?id=com.MKM.app&hl=en_IN", "_blank")} className={`border-radius-70 ${width < 768 ? "w-100 mt-2" : ""}`} src={candymasti} alt="candy-masti"/>
          </Col>
           <Col md={6} className="text-center">
          <img onClick={() => window.open("https://play.google.com/store/apps/details?id=com.darktrigger.app&hl=en_IN", "_blank")} className={`border-radius-70 ${width < 768 ? "w-100 mt-2" : ""}`}  src={darktrigger} alt="dark-trigger"/>
          </Col>
        </Row>
        <div className={`row ${width < 500 ? "mt-3" : "mt-5"}`}>
          <MainHeading title={"Get in contact !"} id={"Contact"} />
        </div>
         <Row className="mt-2">
          <Col md={8} className="text-center m-auto">
            <p className="f-18">
             We’d love to hear from you! Reach out to <b>SLP Technologie IT Solutions</b> for innovative IT services, web development, or custom software solutions. Let’s discuss how we can bring your ideas to life.
            </p>
          </Col>
        </Row>
        <Contact />
      </Container>
      <Footer />
    </>
  );
}

export default App;
